import * as breakpoint from '../utils/breakpoint';
import GroupedContent from '@pixelunion/grouped-content';
import fitvids from 'fitvids';
import debounce from '../utils/debounce';

export default class RTE {
  constructor(el) {
    this.el = el;
    this.originalContent = el.innerHTML;

    this.groupedContent = null;

    const initContent = () => {
      if (breakpoint.min('L')) {
        this._initGroupedContent('tabs');
      } else {
        this._initGroupedContent('accordion');
      }
    };

    // Tabs form a visual border so styling needs updating if they
    // are the first element in a container.
    if (this.el.firstElementChild && this.el.firstElementChild.classList.contains('tabs')) {
      this.el.parentNode.classList.add('no-border');
    }

    initContent();
    fitvids('.rte');

    this.onResize = debounce(() => {
      initContent();
      fitvids('.rte');
    }, 200);
    window.addEventListener('resize', this.onResize);
  }

  _resetContent() {
    if (!this.groupedContent) return;
    this.groupedContent.unload();
    this.el.innerHTML = this.originalContent;
  }

  _initGroupedContent(layout) {
    this._resetContent();
    this.groupedContent = new GroupedContent(this.el, { layout });
  }

  unload() {
    if (this.groupedContent) {
      this.groupedContent.unload();
    }
    window.removeEventListener('resize', this.onResize);
  }
}
